/** Действия маршрута: окна, вкладки, пауза. */
import type { BoostOption } from "@newfungame/engine";
import { appStore, patch, type PauseReason } from "./app-state";
import type { TabId, WindowKind, WindowRoute } from "./routes";

/** Поставить окно в очередь. То же окно (вид) уже в очереди — не дублируем. */
export function openWindow(w: WindowRoute, store = appStore): void {
  patch(
    (s) =>
      s.route.windows.some((x) => x.kind === w.kind) ? {} : { route: { ...s.route, windows: [...s.route.windows, w] } },
    store,
  );
}

/** Закрыть текущее окно (или указанного вида) — откроется следующее в очереди. */
export function closeWindow(kind?: WindowKind, store = appStore): void {
  patch((s) => {
    const windows = kind ? s.route.windows.filter((w) => w.kind !== kind) : s.route.windows.slice(1);
    return windows.length === s.route.windows.length ? {} : { route: { ...s.route, windows } };
  }, store);
}

/** Открыть вкладку (повторно та же — закрыть). */
export function toggleTab(tab: TabId, store = appStore): void {
  patch((s) => ({ route: { ...s.route, tab: s.route.tab === tab ? null : tab } }), store);
}

export function closeTab(store = appStore): void {
  patch((s) => (s.route.tab ? { route: { ...s.route, tab: null } } : {}), store);
}

/** Предложение усилений после волны: кладёт варианты и открывает окно выбора. `null` — убрать. */
export function setBoostOffer(options: BoostOption[] | null, store = appStore): void {
  patch(() => ({ boostOffer: options }), store);
  if (options) openWindow({ kind: "boostChoice" }, store);
  else closeWindow("boostChoice", store);
}

export function setPaused(reason: PauseReason, on: boolean, store = appStore): void {
  patch((s) => {
    const has = s.pause.includes(reason);
    if (has === on) return {};
    return { pause: on ? [...s.pause, reason] : s.pause.filter((r) => r !== reason) };
  }, store);
}
